import classNames from 'classnames';
import Card from './card';
import AvatarTextRow from '../row-items/avatar-text-row';
import CardUnified from './card-unified';
import styles from './card-rewards.module.scss';

export type CardRewardsProps = {
  amount: string;
  avatar:
    | {
        imageUrl: string;
        title: string;
        subtitle?: string;
      }
    | null
    | undefined;
  date: string;
  imageUrl: string;
  type: string;
};

const CardRewards = ({
  amount,
  avatar,
  date,
  imageUrl,
  type,
}: CardRewardsProps) => (
  <Card
    noPadding
    className={classNames(styles.outer, avatar && styles['has-avatar'])}
  >
    {avatar && <AvatarTextRow {...avatar} />}
    <CardUnified
      isRewards={true}
      imageUrl={imageUrl}
      footerLeft={type}
      footerRight={date}
      title={amount}
    />
  </Card>
);

export default CardRewards;
